import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import Subscribe from '@components/pages/Subscribe/index';

registerWithErrorBoundary({
  Subscribe,
});
